import { combineReducers } from 'redux';
import types from './types';

const DEFAULT_DRAFT = {
  numberOfStudents: 141,
  numberOfFaculty: 20,
  studentRoleCharacteristics: {
    annualLearningHours: 1800,
    creditHourCost: 340,
    retentionRate: 0.93,
    percentTimeStudyingOutsideClass: 0.625,
    percentTimeInClass: 0.655,
    studySessionHours: 2,
    recruitmentCostPerStudent: 5885,
    // HC value split per Becker / Mincer theory (user-set 2026-06-27):
    annualForegoneEarningsPerStudent: 50000,   // student-side opportunity cost
    annualCostOfAttendancePerStudent: 30000,    // College Board 2024-25 avg in-state public 4-year sticker
  },
  facultyRoleCharacteristics: {
    annualHours: 1800,
    hourlyCost: 100,
    retentionRate: 0.92,
    recruitmentCostPerFaculty: 50000,
    percentTimeOnTeaching: 0.40,
    percentTimeOnResearch: 0.40,
    percentTimeOnService: 0.20,
  },
  ratings: {
    // v1.5 capability keys -- match HigherEdCapabilitiesValues PHP property names.
    focus: 0,
    classroomTeaching: 0,
    sensoryBiophilic: 0,
    wayfindingLegibility: 0,
    socialBelonging: 0,
    brandRecruitment: 0,
  },
  // Block B (v1.6) faculty-office ratings -- HC's 6 capabilities applied to
  // faculty workspaces. Backend uses these to route through HC engine.
  facultyOfficeRatings: {
    workplace: 0,
    communication: 0,
    activity: 0,
    control: 0,
    groupSpace: 0,
    brand: 0,
  },
};

const assessment = (state = null, action) => {
  switch (action.type) {
    case types.RUN_ASSESSMENT_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const assessments = (state = [], action) => {
  switch (action.type) {
    case types.GET_ASSESSMENTS_SUCCESS:
      return Array.isArray(action.payload) ? action.payload : [];
    default:
      return state;
  }
};

const draft = (state = DEFAULT_DRAFT, action) => {
  switch (action.type) {
    case types.SET_DRAFT:
      return { ...state, ...action.payload.draft };
    case types.HYDRATE_DRAFT:
      // The saga returns the hydrated draft via SET_DRAFT, so HYDRATE_DRAFT
      // itself is just a no-op trigger here.
      return state;
    default:
      return state;
  }
};

const loading = (state = false, action) => {
  switch (action.type) {
    case types.RUN_ASSESSMENT:
    case types.GET_ASSESSMENTS:
      return true;
    case types.RUN_ASSESSMENT_SUCCESS:
    case types.RUN_ASSESSMENT_FAILURE:
    case types.GET_ASSESSMENTS_SUCCESS:
    case types.GET_ASSESSMENTS_FAILURE:
      return false;
    default:
      return state;
  }
};

const error = (state = null, action) => {
  switch (action.type) {
    case types.RUN_ASSESSMENT_FAILURE:
    case types.GET_ASSESSMENTS_FAILURE:
      return action.payload;
    case types.RUN_ASSESSMENT_SUCCESS:
    case types.GET_ASSESSMENTS_SUCCESS:
      return null;
    default:
      return state;
  }
};

export const DEFAULT_HIGHER_ED_DRAFT = DEFAULT_DRAFT;

const topFeatures = (state = [], action) => {
  switch (action.type) {
    case types.GET_TOP_FEATURES_SUCCESS:
      return Array.isArray(action.payload) ? action.payload : [];
    case types.GET_TOP_FEATURES_FAILURE:
      return [];
    default:
      return state;
  }
};

// Higher Ed surveys -- phase 2 (2026-06-28).
const surveys = (state = [], action) => {
  switch (action.type) {
    case types.GET_SURVEYS_SUCCESS:
      return Array.isArray(action.payload) ? action.payload : [];
    case types.GET_SURVEYS_FAILURE:
      return [];
    default:
      return state;
  }
};

const surveyDetails = (state = null, action) => {
  switch (action.type) {
    case types.GET_SURVEY_DETAILS_SUCCESS:
      return action.payload;
    case types.GET_SURVEY_DETAILS_FAILURE:
    case types.RESET_SURVEY_DETAILS:
      return null;
    default:
      return state;
  }
};

const reducer = combineReducers({
  assessment,
  assessments,
  draft,
  loading,
  error,
  topFeatures,
  surveys,
  surveyDetails,
});

export default reducer;
